var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundLicenseplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 64,
    viewBox: "0 0 296 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.505 2.1875H6.49569C3.91867 2.1875 1.82959 4.27461 1.82959 6.84919V57.7391C1.82959 60.3137 3.91867 62.4008 6.49569 62.4008H289.505C292.082 62.4008 294.171 60.3137 294.171 57.7391V6.84919C294.171 4.27461 292.082 2.1875 289.505 2.1875Z",
    fill: "#FBBC01",
    stroke: "black",
    strokeWidth: 3.0928
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5263 2.37821V62.3739H6.40761C3.68558 62.3637 2.30303 61.0152 1.92627 58.6619L2.00817 6.99327C2.33822 4.2463 3.73166 2.56173 6.40761 2.15845L29.5263 2.37821Z",
    fill: "#003399",
    stroke: "#003399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51416 51.214V40.3386H10.4559L14.5011 47.6012V40.3386H16.3551V51.214H14.3527L10.3682 44.122V51.214H8.51416ZM18.5261 51.214V40.4276H20.5217V49.3816H25.4838V51.214H18.5261Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4957 3.73391C4.77136 3.73391 3.376 5.13005 3.376 6.84921V57.7391C3.376 59.4583 4.77136 60.8544 6.4957 60.8544H289.505C291.229 60.8544 292.625 59.4583 292.625 57.7391V6.84921C292.625 5.13005 291.229 3.73391 289.505 3.73391H6.4957ZM0.283203 6.84921C0.283203 3.41919 3.06601 0.641113 6.4957 0.641113H289.505C292.935 0.641113 295.717 3.41919 295.717 6.84921V57.7391C295.717 61.1691 292.935 63.9472 289.505 63.9472H6.4957C3.06601 63.9472 0.283203 61.1691 0.283203 57.7391V6.84921Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLicenseplate);
export default __webpack_public_path__ + "static/media/background-licenseplate.8c1568bc6b14272067dd7ca734dea19f.svg";
export { ForwardRef as ReactComponent };